<template>
  <div class="public-percent" :style="'width:' + size + 'px;height:' + size + 'px'">
    <svg :width="size" :height="size" class="public-percentSvg">
      <circle :cx="xy" :cy="xy" :r="r" :stroke-width="borderSize" :stroke="borderBg" fill="none" />
      <circle
        :cx="xy"
        :cy="xy"
        :r="r"
        :stroke-width="borderSize"
        :stroke="borderColor"
        fill="none"
        :stroke-dasharray="perimeterEnd"
      >
        <animate
          attributeName="stroke-dasharray"
          :from="perimeterStart"
          :to="perimeterEnd"
          :dur="speed + 's'"
          begin="0s"
        />
      </circle>
    </svg>
    <div class="public-percentBox">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Percentloop from "./percentloop.js"
export default Percentloop;
</script>

<style lang="less" scoped>
@import "./percentloop.less";
</style>